import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ClientStorageKeys } from 'src/app/core/services/local-storage/client-storage.keys';
import { ClientStorageService } from 'src/app/core/services/local-storage/client-storage.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { AchievementsService } from '../achievements.service';
import { BadgesFeatureService } from '../badges-feature';
import { AchievementsWelcomeDialogComponent } from './achievements-welcome-dialog.component';

/**
 * Shows the one-time achievements announcement to a logged-in user. The server flag is the
 * source of truth; localStorage only avoids repeating the request on every page load.
 */
@Injectable({ providedIn: 'root' })
export class AchievementsWelcomeService {
  private checked = false;

  constructor(
    private achievementsService: AchievementsService,
    private clientStorage: ClientStorageService,
    private userService: UserService,
    private matDialog: MatDialog,
    private badgesFeature: BadgesFeatureService
  ) {}

  checkOnce(): void {
    // Before launch the server answers "don't show", which would be stored as seen below and
    // hide the welcome for good, so nothing is asked while the feature is off.
    if (this.checked || !this.userService.userHasLoggedIn || !this.badgesFeature.isEnabled) {
      return;
    }
    if (this.clientStorage.getValue(ClientStorageKeys.AchievementsWelcomeSeen) === 'true') {
      this.checked = true;
      return;
    }
    this.checked = true;

    this.achievementsService.getWelcomeState().subscribe(
      state => {
        if (!state?.shouldShow) {
          this.clientStorage.setValue(ClientStorageKeys.AchievementsWelcomeSeen, 'true');
          return;
        }
        this.matDialog
          .open(AchievementsWelcomeDialogComponent, {
            data: state,
            autoFocus: false,
            disableClose: true,
            panelClass: 'badge-dialog-panel',
            width: '520px',
            maxWidth: 'calc(100vw - 32px)',
          })
          .afterClosed()
          .subscribe(() => this.dismiss());
      },
      () => (this.checked = false)
    );
  }

  private dismiss(): void {
    this.clientStorage.setValue(ClientStorageKeys.AchievementsWelcomeSeen, 'true');
    this.achievementsService.dismissWelcome().subscribe();
  }
}
